import { isNil } from 'lodash-es';

export const shouldEnableDebtAssociated = (
  totalDebtCents?: number | null,
  annualDebtPaymentsCents?: number | null,
): boolean => {
  const hasTotalDebtCents =
    !isNil(totalDebtCents) && Number(totalDebtCents) > 0;
  const hasAnnualDebtPaymentsCents =
    !isNil(annualDebtPaymentsCents) && Number(annualDebtPaymentsCents) > 0;
  return hasTotalDebtCents || hasAnnualDebtPaymentsCents;
};

export const shouldEnableSourceOfWealthAndFunds = (
  annualIncomeCents?: number | null,
  financialLiquidAssetsCents?: number | null,
  financialFixedAssetsCents?: number | null,
): boolean => {
  const hasAnnualIncome =
    !isNil(annualIncomeCents) && Number(annualIncomeCents) > 0;
  const hasLiquidAssetsCents =
    !isNil(financialLiquidAssetsCents) &&
    Number(financialLiquidAssetsCents) > 0;
  const hasFixedAssetsCents =
    !isNil(financialFixedAssetsCents) && Number(financialFixedAssetsCents) > 0;
  return hasAnnualIncome || hasLiquidAssetsCents || hasFixedAssetsCents;
};
